import { Image } from '@chakra-ui/react';

import { ThemeIcon, ThemeIconProps } from '../../components';
import DarkLogo from './assets/blockpulse_icon_dark.svg';
import LightLogo from './assets/blockpulse_icon_light.svg';

function LightIcon(): JSX.Element {
  return <Image alt="Blockpulse" maxH="100%" src={LightLogo} />;
}

function DarkIcon(): JSX.Element {
  return <Image alt="Blockpulse" maxH="100%" src={DarkLogo} />;
}

export function Icon({ ...props }: ThemeIconProps): JSX.Element {
  return <ThemeIcon darkIcon={<DarkIcon />} lightIcon={<LightIcon />} {...props} />;
}
